<template>
  <Offcanvas :config="offcanvas">
    <template v-slot:header>
      <p class="modal-card-title">{{translations.new_device_category}}</p>
    </template>

    <Input :config="form.name" v-model="deviceCategory.name" />
    <Textarea :config="form.description" v-model="deviceCategory.description" />

    <template v-slot:footer>
      <div class="buttons">
        <button class="button is-success is-fullwidth" @click="submit()">{{translations.create}}</button>
      </div>
    </template>
  </Offcanvas>
</template>

<script lang="ts">
// @ is an alias to /src
import { IOffcanvas } from '@/components';
import { IInput } from '@/components/form';
import Input from '@/components/form/input.vue';
import Select from '@/components/form/select.vue';
import Textarea from '@/components/form/textarea.vue';
import Offcanvas from '@/components/offcanvas.vue';
import router from '@/router';
import store from '@/store';
import { IStateDeviceCategory } from '@/store/modules/deviceCategories';
import { IDeviceCategoriesTranslations } from '@/translations';
import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';

import {
  deviceCategory,
  deviceCategoryOffcanvas,
  form,
  IDeviceCategoryForm
} from './../DeviceCategories.data';

@Component({
  name: 'AddDevice',
  components: { Offcanvas, Input, Select, Textarea }
})
class AddDevice extends Vue {
  @Action('addDeviceCategory') public add!: (deviceCategory: IStateDeviceCategory) => void;

  @Getter('getDeviceCategoriesTranslations') public translations!: IDeviceCategoriesTranslations;
  public offcanvas = deviceCategoryOffcanvas;
  public form!: IDeviceCategoryForm; public deviceCategory = deviceCategory;
  public created() {
    this.form = form(this.translations);
  }
  public submit() {
    this.add(this.deviceCategory);
    router.push('/devices/categories');
  }
  public discard() {
    router.push('/devices/categories');
  }
}

export default AddDevice;
</script>
